import React, { useState } from "react";
import { Plus } from "react-bootstrap-icons";
import BottomTray from "./BottomTray";
import CreateNewList from "./CreateNewList";

const SaveToList = ({
  savedLists,
  handleListClick,
  isProductInList,
  invitedLists,
  invitedListsStatus,
  handleInvitedListClick,
  closeTray,
  handleCreateNewList,
  newListName,
  setNewListName,
  error,
  setError,
  loading,
  isSubmitted,
  setIsSubmitted,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div style={{ paddingTop: "12px" }} onClick={(e) => e.stopPropagation()}>
      <ul
        className="navbar-nav d-flex flex-column gap-2"
        style={{ maxHeight: "17rem", overflow: "auto" }}
      >
        {savedLists.map((list) => (
          <li key={list?.id}>
            <div
              className="d-flex align-items-center justify-content-between bg-white shadow-sm px-3 py-2 rounded-3"
              style={{ cursor: "pointer" }}
              onClick={() => handleListClick(list?.id, "", list?.listId)}
            >
              <div className="text-truncate h6 mb-0 fw-light">
                {list?.listName}
              </div>
              <input
                type="checkbox"
                style={{ width: "15px", height: "15px" }}
                checked={isProductInList(list?.id)}
                readOnly
              />
            </div>
          </li>
        ))}

        {/* Render Invited Lists */}
        {invitedLists.map((list) => (
          <li key={list?.id}>
            <div
              key={list.listId}
              className="d-flex align-items-center justify-content-between bg-white shadow-sm px-3 py-2 rounded-3"
              style={{ cursor: "pointer" }}
              onClick={() => handleInvitedListClick(list)}
            >
              <div className="d-flex justify-content-between w-100 me-3">
                {list?.listName}
                <div className="text-truncate h6 mb-0 fw-light">
                  <i>by {list.inviterName}</i>
                </div>
              </div>
              <input
                type="checkbox"
                style={{ width: "15px", height: "15px" }}
                checked={invitedListsStatus[list?.id] || false}
                readOnly
              />
            </div>
          </li>
        ))}

        {/* Divider */}
        {(savedLists.length > 0 || invitedLists.length > 0) && (
          <li>
            <hr className="dropdown-divider" />
          </li>
        )}
      </ul>
      <div className="pt-2 d-flex flex-column gap-3">
        {/* Create New List */}
        <div
          className="d-flex align-items-center justify-content-between bg-white shadow-sm px-3 py-2 rounded-3 border btn btn-primary-soft"
          onClick={() => setIsOpen(true)}
        >
          <div>Create New List</div>
          <div>
            <Plus className="fs-4" />
          </div>
        </div>
        <BottomTray
          text={"Create New List"}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        >
          <CreateNewList
            handleCreateNewList={handleCreateNewList}
            error={error}
            newListName={newListName}
            setError={setError}
            setNewListName={setNewListName}
            loading={loading}
            isSubmitted={isSubmitted}
            setIsSubmitted={setIsSubmitted}
            parentCloseTray={closeTray}
          />
        </BottomTray>
      </div>
    </div>
  );
};

export default SaveToList;
